import { CREDIT_ACTION_TYPES } from '../actions/types';

const initialState = {
  creditList: [],
  walletBalance: null,
  walletBalanceLoading: false,
  walletBalanceError: null,
  loading: false,
  error: null,
};

const creditReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREDIT_ACTION_TYPES.FETCH_CREDIT_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case CREDIT_ACTION_TYPES.FETCH_CREDIT_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        creditList: action.payload,
        error: null,
      };

    case CREDIT_ACTION_TYPES.FETCH_CREDIT_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CREDIT_ACTION_TYPES.FETCH_WALLET_BALANCE_REQUEST:
      return {
        ...state,
        walletBalanceLoading: true,
        walletBalanceError: null,
      };

    case CREDIT_ACTION_TYPES.FETCH_WALLET_BALANCE_SUCCESS:
      return {
        ...state,
        walletBalanceLoading: false,
        walletBalance: action.payload,
        walletBalanceError: null,
      };

    case CREDIT_ACTION_TYPES.FETCH_WALLET_BALANCE_FAILURE:
      return {
        ...state,
        walletBalanceLoading: false,
        walletBalanceError: action.payload,
      };

    case CREDIT_ACTION_TYPES.CLEAR_CREDIT_ERRORS:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export default creditReducer;
